/**
 * Keeps a keyboard-focused collection menu link fully in view.
 *
 * The menu is a horizontal scroller. Chrome does not scroll a partially visible
 * link into view on Tab, so the trailing item can stay clipped by the scroll
 * container. Scrolling it in honours the menu's scroll-padding, which also keeps
 * the link clear of the edge fades.
 *
 * Delegated from the document so one listener covers every menu on the page and
 * keeps working after the results area re-renders. Loaded as a module, which
 * evaluates once even though the snippet renders more than once per page.
 */
(function collectionMenuFocusScroll() {
  document.addEventListener('focusin', (event) => {
    const link = event.target;

    if (!(link instanceof HTMLElement)) return;
    // :focus-visible keeps a mouse click from jumping the menu before it navigates.
    if (!link.matches('.collection-menu__link:focus-visible')) return;

    link.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
  });
})();
